export const partnerKeys = {
    all: ['partners'] as const,
    lists: () => [...partnerKeys.all, 'list'] as const,
    details: (id: string) => [...partnerKeys.all, 'details', id] as const,
  };